"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestRoutes = void 0;
const route_1 = require("../route");
class RequestRoutes extends route_1.Route {
    constructor() {
        super('requests');
    }
    sendRequest(recipientId, amount, note) {
        return this.post('/', { recipientId, amount, note });
    }
    respondToRequest(requestId, action) {
        return this.put(`/${requestId}`, { action });
    }
}
exports.RequestRoutes = RequestRoutes;
//# sourceMappingURL=requests.js.map